<div class="modal-header">
  <b class="__title">{{ 'common.createTask' | translate }}</b>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <hr class="simple-separator">
</div>
<div class="modal-body">

  <div class="inner-modal-body">
   
    <section id="view-content">

      <div class="description-container">
        <form [formGroup]="taskForm">
          <div class="form-group">
            <textarea class="form-control"
              placeholder="{{ 'common.writeTask' | translate}}"
              formControlName="taskName"
              [readonly]="(readOnly || this.currentTask)"
              [ngClass]="{
                'is-invalid': !taskForm.get('taskName').valid && taskForm.get('taskName').errors?.submitted
              }">
            </textarea>

            <div class="invalid-feedback">
              {{ taskForm.get('taskName').errors?.message ? 
              taskForm.get('taskName').errors.message :  
              ("task.warnings.no-valid" | translate) 
              }}
            </div>
          </div>

        </form>
        <!-- <div class="textarea" *ngIf="readOnly || this.currentTask">
          {{ taskForm.get('taskName')?.value }}
        </div> -->
      </div>

      <div class="progressbar" #progressBar>
        <mat-slider
          color="primary"
          [max]="max"
          [min]="min"
          [step]="step"
          [disabled]="readOnly"
          [(ngModel)]="progress">
        </mat-slider>

        <div class="__details gs keep-lay">
          <div class="lay align-left">
            <span>{{ "task.completedPercentage" | translate }}</span>
          </div>
          <div class="lay align-right">
            <span>{{ progress === 0 ? '0%' : (progress + '%') }}</span>
          </div>
        </div>

      </div>
      
      <div class="gs">
        <div class="lay-80">
          <div class="row-button __actions gs keep-lay" *ngIf="!readOnly">
            <div class="lay-50 p-10-right">
              <button mat-stroked-button class="btn-block sm" color="primary"
                [disabled]="loading"
                (click)="cancel()">
                <span class="capitalize"> {{ "common.cancel" | translate }} </span>
              </button>
            </div>
            <div class="lay-50 p-10-left">
              <button mat-raised-button class="btn-block sm" color="primary"
                [disabled]="loading"
                (click)="save(taskForm)">
                <span class="capitalize"> {{ "common.save" | translate }} </span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </section>

  </div>
</div>